import * as constants from '../constants';

// Aggiunti i brand dependent filters anche i nuovi custom
// constants.CLASSE_CATEGORIA_SCONTO_VENDITA,constants.CLASSE_PRODOTTO,constants.TIPO_ARTICOLO,constants.CATEGORIA_MERCEOLOGICA,
export const brandDependentFilters = [
    constants.STATUS_FILTER,
    constants.LINE_FILTER,
    constants.MODEL_FILTER,
    constants.SERIES_FILTER,
    constants.LISTINI_FILTER,
    constants.FUORI_CARTACEO_FILTER,
    constants.CLASSE_CATEGORIA_SCONTO_VENDITA,
    constants.CLASSE_PRODOTTO,
    constants.TIPO_ARTICOLO,
    constants.CATEGORIA_MERCEOLOGICA,
    constants.FUORI_CARTACEO_FILTER
];